/* eslint-env jquery */
/**
 * @license
 * Copyright (c) 2015 Example Corporation Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
const setSubmenuPosition = (e) => {
  const $submenu = jQuery('.menu-container');
  if ($submenu.length) {
    let headerHeight = jQuery('header.pos_fixed').height() | 0;
    headerHeight -= 2;
    if (jQuery(window).scrollTop() > 1) {
      $submenu.addClass('sticky');
      $submenu.css('top', `${headerHeight}px`);
      jQuery('.barra-titulo').css('margin-top', `${(headerHeight + $submenu.height())}px`);
    } else {
      $submenu.removeClass('sticky');
      $submenu.css('top', '0px');
      jQuery('.barra-titulo').css('margin-top', '0px');
    }
  }
};

jQuery(window).on('load resize scroll', setSubmenuPosition);

jQuery(document).ready(function () {
  if (jQuery(window).width() >= 640) {
    const heights = jQuery('.misma-altura').map(function () {
      return jQuery(this).height();
    }).get();
    const maxHeight = Math.max.apply(null, heights);
    jQuery('.misma-altura').height(maxHeight);
  }
});
